module.exports = __webpack_public_path__ + "img/antena3.1dd886e0.svg";